import { render, staticRenderFns } from "./luckyNangkwak.vue?vue&type=template&id=75d2e6b7&scoped=true"
import script from "./luckyNangkwak.vue?vue&type=script&lang=js"
export * from "./luckyNangkwak.vue?vue&type=script&lang=js"
import style0 from "./luckyNangkwak.vue?vue&type=style&index=0&id=75d2e6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2e6b7",
  null
  
)

export default component.exports